import { Paper } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { withSnackbar } from 'notistack'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import MapForm from '../../components/MapForm'
import { withEpisodes } from '../../contexts/data-context'
import Helper from '../../utils/Helper'
import { doAndSnack } from '../../utils/snackbar'

const styles = theme => ({
  root: {},
  paper: {
    marginTop: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column',
  },
})

class MapDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      map: null,
    }
  }
  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    const { id } = this.props.match.params
    const map = await Helper.ApiRequest(`/maps/${id}`)
    this.setState({ map })
  }

  save = () => {
    const { map } = this.state
    const { enqueueSnackbar } = this.props
    const [promise, onSuccess] = this.getSaveRequest(map)
    doAndSnack(promise, enqueueSnackbar, {
      success: 'Map succesfully saved',
      fail: 'Failed to save map',
      onSuccess,
    })
  }

  getSaveRequest = map => {
    const { history } = this.props
    const { _id } = map
    const path = `/maps/${_id}`
    const method = 'PUT'
    const body = JSON.stringify(map)
    const promise = Helper.ApiRequest(path, { method, body })

    const onSuccess = () => {
      history.push(`/maps/${_id}`)
      this.fetchData()
    }
    return [promise, onSuccess]
  }
  handleChange = map => {
    this.setState({ map })
  }
  render() {
    const { classes } = this.props
    const { map } = this.state
    if (!map) return null

    return (
      <React.Fragment>
        <FormTitle map={map} />
        <Paper className={classes.paper}>
          <MapForm map={map} onChange={this.handleChange} onSave={this.save} />
        </Paper>
      </React.Fragment>
    )
  }
}

MapDetail.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withSnackbar(
  withEpisodes(withRouter(withStyles(styles)(MapDetail)))
)

function FormTitle({ map }) {
  const { item = {} } = map || {}
  const {title} = item
  return (
    <Typography component="h2" variant="h4" align="center">
      Map : {title}
    </Typography>
  )
}
